import { EDUCATORS_SIGNUP_ANSWERS } from '@src/constants/educators';

/**
 * Whether the signup survey answers say this account belongs in Educators mode.
 * One matching answer is enough — a teacher who also makes marketing videos is
 * still a teacher.
 *
 * `steps` is the survey payload keyed by question, the same shape the survey
 * submits and `GET /surveys/user` returns. Every answer in it is read, so an
 * option that moves to another question, or a survey that rewrites its questions
 * altogether, still counts for what it says.
 */
export const hasEducatorsSignupAnswer = (steps) =>
  Object.values(steps || {}).some((answer) =>
    (answer?.selectedOptions || []).some((option) =>
      EDUCATORS_SIGNUP_ANSWERS.includes(option?.key),
    ),
  );
